class ScrollHeader {
    constructor() {
        this.header = document.querySelector(".header");
        this.stickPoint = this.header.offsetTop;
        this.stuck = false;
        this.lastScrollPos = window.scrollY;
        this.headerMenu = document.querySelector(".header__menu");
        if (this.header && this.headerMenu) {
            this.events();
        }
    }

    events() {
        window.addEventListener("scroll", () => {
            const currentPosition = window.scrollY;
            const distance = this.stickPoint - currentPosition;
            const scrollDirection = currentPosition > this.lastScrollPos ? 'down' : 'up';

            if (scrollDirection === 'down') {
                if (!this.header.classList.contains('slide-out')) {
                    this.header.classList.add('slide-out');
                }
            }
            else if (scrollDirection === 'up') {
                if (this.header.classList.contains('slide-out')) {
                    this.header.classList.remove('slide-out');
                }
            }
            if (distance <= 0 && !this.stuck) {
                this.header.classList.add("header--solid");
                this.headerMenu.classList.add("header__menu--solid");
                this.stuck = true;

            } else if (this.stuck && currentPosition <= this.stickPoint) {
                this.header.classList.remove("header--solid");
                this.headerMenu.classList.remove("header__menu--solid");
                this.stuck = false;
            }

            this.lastScrollPos = currentPosition;
        });
    }
}
export default ScrollHeader;
